export default {
  frontend_groovemail_forms_view_email: 'Email precisa ser um email válido',
  frontend_groovemail_forms_view_confirm_email: 'Por favor confirme o seu email para fazer optin',
  frontend_cancel: 'Cancelar',
  frontend_groovemail_frontend_confirm: 'Confirmar',
  frontend_groovemail_settings_integeration_invalid_phone_number: 'Invalid phone number',
  frontend_send: 'Enviar',
  frontend_groovemail_forms_view_invalid_data: 'Dado Inválido',
  frontend_close: 'Fechar',
  frontend_groovemail_forms_view_unknown_backend_error: 'Ocorreu Um Erro Desconhecido no Backend. Por favor recarregar (F5) esta página e tente novamente. Se o erro persistir, por favor entre em contato com o nosso suporte',
};
